import { css, keyframes } from '@emotion/css';

export const load8 = keyframes`
   0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

export const loader = props => css`
  border-top: 1.5px solid rgba(58,131,249, 0.2);
  border-right: 1.5px solid rgba(58,131,249, 0.2);
  border-bottom: 1.5px solid rgba(58,131,249, 0.2);
  border-left: 1.5px solid #3a83f9;
  border-radius: 50%;
  ${props.width 
    ? `width: ${props.width};`
    : 'width: 64px;'}
  ${props.height 
    ? `height: ${props.height};`
    : 'height: 64px;'}
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: ${load8} 1.1s infinite linear;
  animation: ${load8} 1.1s infinite linear; */
`;
